import { render } from "./detail-ir.vue?vue&type=template&id=60fa9dbc"
import script from "./detail-ir.vue?vue&type=script&lang=js"
export * from "./detail-ir.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__